import { BulkShiftForm } from './bulk-shift-archive-form';

export const BulkShiftArchiveFormProvider = () => {
  return <BulkShiftForm />;
};
